import { render, staticRenderFns } from "./SideSheet.vue?vue&type=template&id=c3ae8a7a&scoped=true"
import script from "./SideSheet.vue?vue&type=script&lang=ts"
export * from "./SideSheet.vue?vue&type=script&lang=ts"
import style0 from "./SideSheet.vue?vue&type=style&index=0&id=c3ae8a7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ae8a7a",
  null
  
)

export default component.exports